// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solutions__intro {
  margin-bottom: clamp(2.5rem, 6vw, 4rem);
}

.solutions__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(1.25rem, 3vw, 2rem);
}

.solution-card {
  display: grid;
  grid-template-rows: auto 1fr;
  border: 1px solid var(--line);
  border-radius: 6px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.55);
}

.solution-card__media {
  display: block;
  position: relative;
  min-height: 220px;
  overflow: hidden;
}

.solution-card__media::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(15, 46, 36, 0.18), transparent 55%);
  pointer-events: none;
}

.solution-card__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s ease;
}

.solution-card:hover .solution-card__media img {
  transform: scale(1.035);
}

.solution-card__body {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: clamp(1.25rem, 3vw, 1.75rem);
  height: 100%;
}

.solution-card__meta {
  display: flex;
  gap: 1rem;
  font-family: var(--font-display);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--moss);
}

.solution-card__title {
  max-width: 18ch;
  font-family: var(--font-display);
  font-size: clamp(1.25rem, 2.2vw, 1.55rem);
  font-weight: 600;
  line-height: 1.18;
  letter-spacing: -0.03em;
  color: var(--ink);
}

.solution-card__title a:hover {
  color: var(--moss);
}

.solution-card__text {
  color: var(--muted);
}

.solution-card__partner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.95rem;
  color: var(--text);
}

.solution-card__partner:hover {
  color: var(--moss);
}

.solution-card__partner-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
  padding: 0.25rem;
  border: 1px solid var(--line);
  border-radius: 4px;
  background: #fff;
}

.solution-card__partner strong {
  font-weight: 600;
  color: var(--ink);
}

.solution-card__partner--note {
  margin: 0;
  font-weight: 500;
  color: var(--moss);
}

.solution-card__actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 0.55rem;
  margin-top: auto;
  padding-top: 0.5rem;
}

.solution-card__actions .btn {
  flex: 1 1 0;
  min-width: 0;
  min-height: 2.75rem;
  padding: 0.7rem 0.75rem;
  font-size: 0.92rem;
  white-space: nowrap;
}

@media (max-width: 1100px) {
  .solutions__grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 720px) {
  .solutions__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Solutions.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4EAA4E;EAC5E,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".solutions__intro {\r\n  margin-bottom: clamp(2.5rem, 6vw, 4rem);\r\n}\r\n\r\n.solutions__grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: clamp(1.25rem, 3vw, 2rem);\r\n}\r\n\r\n.solution-card {\r\n  display: grid;\r\n  grid-template-rows: auto 1fr;\r\n  border: 1px solid var(--line);\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n  background: rgba(255, 255, 255, 0.55);\r\n}\r\n\r\n.solution-card__media {\r\n  display: block;\r\n  position: relative;\r\n  min-height: 220px;\r\n  overflow: hidden;\r\n}\r\n\r\n.solution-card__media::after {\r\n  content: '';\r\n  position: absolute;\r\n  inset: 0;\r\n  background: linear-gradient(135deg, rgba(15, 46, 36, 0.18), transparent 55%);\r\n  pointer-events: none;\r\n}\r\n\r\n.solution-card__media img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  transition: transform 0.7s ease;\r\n}\r\n\r\n.solution-card:hover .solution-card__media img {\r\n  transform: scale(1.035);\r\n}\r\n\r\n.solution-card__body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.85rem;\r\n  padding: clamp(1.25rem, 3vw, 1.75rem);\r\n  height: 100%;\r\n}\r\n\r\n.solution-card__meta {\r\n  display: flex;\r\n  gap: 1rem;\r\n  font-family: var(--font-display);\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n  color: var(--moss);\r\n}\r\n\r\n.solution-card__title {\r\n  max-width: 18ch;\r\n  font-family: var(--font-display);\r\n  font-size: clamp(1.25rem, 2.2vw, 1.55rem);\r\n  font-weight: 600;\r\n  line-height: 1.18;\r\n  letter-spacing: -0.03em;\r\n  color: var(--ink);\r\n}\r\n\r\n.solution-card__title a:hover {\r\n  color: var(--moss);\r\n}\r\n\r\n.solution-card__text {\r\n  color: var(--muted);\r\n}\r\n\r\n.solution-card__partner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  font-size: 0.95rem;\r\n  color: var(--text);\r\n}\r\n\r\n.solution-card__partner:hover {\r\n  color: var(--moss);\r\n}\r\n\r\n.solution-card__partner-logo {\r\n  width: 40px;\r\n  height: 40px;\r\n  object-fit: contain;\r\n  flex-shrink: 0;\r\n  padding: 0.25rem;\r\n  border: 1px solid var(--line);\r\n  border-radius: 4px;\r\n  background: #fff;\r\n}\r\n\r\n.solution-card__partner strong {\r\n  font-weight: 600;\r\n  color: var(--ink);\r\n}\r\n\r\n.solution-card__partner--note {\r\n  margin: 0;\r\n  font-weight: 500;\r\n  color: var(--moss);\r\n}\r\n\r\n.solution-card__actions {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: stretch;\r\n  gap: 0.55rem;\r\n  margin-top: auto;\r\n  padding-top: 0.5rem;\r\n}\r\n\r\n.solution-card__actions .btn {\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n  min-height: 2.75rem;\r\n  padding: 0.7rem 0.75rem;\r\n  font-size: 0.92rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n@media (max-width: 1100px) {\r\n  .solutions__grid {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .solutions__grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
